"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductInWishList = void 0;
const isProductInWishList = (wishListProducts, productId, colorId) => !!(wishListProducts === null || wishListProducts === void 0 ? void 0 : wishListProducts.find(wishListProduct => wishListProduct.colorId === colorId && wishListProduct.productId === productId));
exports.isProductInWishList = isProductInWishList;
